type OsTypes = 'iOS' | 'iPhone OS' | 'Android' | 'Windows Phone' | 'Windows' | 'Mac OS';

export const isTargetOs = (os: OsTypes): boolean => {
    const { userAgent } = navigator;
    const osRegExp = new RegExp(os, 'i');
    return osRegExp.test(userAgent);
};
